import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-program-list',
  templateUrl: './dialog-program-list.component.html',
  styleUrls: ['./dialog-program-list.component.css']
})

export class DialogProgramListComponent implements OnInit {
  confirmText: any;
  selectedProgramId: any;
  constructor(private dialogRef: MatDialogRef<DialogProgramListComponent>, @Inject(MAT_DIALOG_DATA) _data) {
    this.confirmText = _data;
  }

  ngOnInit() {
  }

  close() {
    localStorage.setItem('programId', this.selectedProgramId);
    this.dialogRef.close();
  }
  
  filterProgram(event: any) {
    localStorage.setItem('programId', event.target.value);
  }
}

